import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { IEmpDlts } from "../../models/EmpDlts";
import { EmptyEmpDlts } from "./EmptyEmpDlts";
// import { Form } from "./Form";
import { Table } from "./Table";
import { IPermissionProps } from "../../models/Login";

export interface IModel1 {
    open: boolean,
    singleData: IEmpDlts
}

export const EmpDlts = (permissions: IPermissionProps) => {

    const [modal1, setModal1] = useState({ singleData: EmptyEmpDlts, open: false } as IModel1);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    return (
        <>
            <Table permissions={permissions} setModal={setModal1} toast={toast} reload={reload}  ></Table>
            <Toast ref={toast} />
        </>
    );
}
